import { render, staticRenderFns } from "./PFDeferredSettlement.vue?vue&type=template&id=6c47f19f"
import script from "./PFDeferredSettlement.vue?vue&type=script&lang=js"
export * from "./PFDeferredSettlement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports